import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 75 75",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 75 75\" id=\"play\"><path fill=\"#fff\" d=\"m57.5 38.5-32 16v-32z\" /><path fill=\"none\" stroke=\"#fff\" stroke-miterlimit=\"50\" stroke-width=\"5\" d=\"M2.5 37.5a35 35 0 1 1 70 0 35 35 0 0 1-70 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol